import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" stroke="#000" {...props}><circle r="10" cx="10" cy="10" stroke="none" /></svg>;